import type {
  CatalogAssetListItem,
  MediaLibraryAssetItem,
} from "@/types/catalogAssets";

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${Math.round(kb)} KB`;
  return `${(kb / 1024).toFixed(1)} MB`;
}

export function mediaCardSubtitle(
  asset: MediaLibraryAssetItem,
): string | undefined {
  const parts: string[] = [];
  if (asset.width_px && asset.height_px) {
    parts.push(`${String(asset.width_px)} × ${String(asset.height_px)} px`);
  }
  if (asset.file_size && asset.file_size > 0) {
    parts.push(formatFileSize(asset.file_size));
  }
  return parts.length > 0 ? parts.join(" • ") : undefined;
}

/** Secondary caption line: origin and/or "Generated", as plain text. */
export function mediaCardMeta(
  asset: Pick<CatalogAssetListItem, "origin" | "source">,
): string | undefined {
  const parts: string[] = [];
  if (asset.origin != null) parts.push(asset.origin);
  if (asset.source === "ai_generated") parts.push("Generated");
  return parts.length > 0 ? parts.join(" • ") : undefined;
}

export function mediaCardTitle(asset: MediaLibraryAssetItem): string {
  return asset.title.trim() || asset.product_title || asset.handle;
}

export function matchesQuery(
  asset: MediaLibraryAssetItem,
  query: string,
): boolean {
  return [
    asset.title,
    asset.handle,
    asset.alt,
    asset.file_name,
    asset.product_title,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase()
    .includes(query);
}
